import { Box } from "@mui/material";
import { useTheme } from "@mui/material/styles";

const WidgetSurveyContent = props => {
  const theme = useTheme();
  return (
    <Box
      sx={{
        margin: 0,
        padding: 0,
        // Single source of truth for table margins: left / right / bottom all
        // use the same spacing so every table sits flush-consistent inside its
        // widget (the bottom of the table — incl. any pagination control — gets
        // the same gap as the sides).
        paddingLeft: theme.spacing(2),
        paddingRight: theme.spacing(2),
        paddingBottom: theme.spacing(0.5),
        display: "flex",
        flexDirection: "column",

        backgroundColor: theme.palette.commonground.main,
        height: "calc(100% - 56px)",
        boxSizing: "border-box",
        overflowY: "hidden",
        overflowX: "hidden",
      }}
    >
      {props.children}
    </Box>
  );
};

export default WidgetSurveyContent;
